// Frameworks
import React, { Component } from 'react'
import styled from 'styled-components'

const LogOutWrap = styled.section``

class LogOut extends Component {
  render () {
    return (
      <LogOutWrap>
        <h4>Log out</h4>
        <h6>Goodbye. Adios. Auf Wiedersehen.</h6>
      </LogOutWrap>
    )
  }
}

export default LogOut



// WEBPACK FOOTER //
// ./src/components/LogOut.js